<template>
    <div>
        <h1 class="page-title">Страница не найдена :(</h1>
    </div>
</template>

<script>
export default {
    name: "404"
}
</script>

<style scoped>

</style>